module.exports = __webpack_public_path__ + "static/media/safeData.65cfd2ac.png";